export default __webpack_public_path__ + "static/media/028-sunglasses.abdcc373.svg";